// extracted by mini-css-extract-plugin
module.exports = {"fav__actions":"favoriteheader_fav__actions__X_lCP","fav__actions_label":"favoriteheader_fav__actions_label__sVYjI","counter":"favoriteheader_counter__O_0Wa"};